'use strict';
'use es6';

// Stolen from enviro. wanted to remove deps

Object.defineProperty(exports, "__esModule", {
  value: true
});
var qaRegex = /(?:hubspot|hubteam|grader|getsignals|getsidekick|gettally|leadin|hubspotemail|customer-hub|hubspotservicehub)qa\.com|(?:hubspotstarter|hubspotfree)qa\.net|(?:growth)qa\.org/;
var isProd = function isProd() {
  return !qaRegex.test(document.location.host);
};

exports.default = {
  isProd: isProd
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/utilities/enviro.js
// module id = 280
// module chunks = 3 4 5